import useSWR, { SWRConfiguration } from "swr";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { calcUrl, SWRObjectKey } from "@/features/ui/helpers/fetcher-helpers";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";

// (부티크) 라인시트세트의 모든 오더를 한 번에 부티크 확정(바이어 승인 필요)한다.
// 오더마다 확정 수량을 다 넣었을 때만 된다.

export interface BoutiqueConfirmReadinessOrder {
  id: number;
  buyerName: string | null;
  status: OrderSheetStatus;
  optionCount: number;
  // 확정 수량을 아직 넣지 않은 옵션 수
  unconfirmedOptionCount: number;
  isReady: boolean;
}

export interface BoutiqueConfirmReadinessResponse {
  orders: BoutiqueConfirmReadinessOrder[];
  totalCount: number;
  readyCount: number;
  allReady: boolean;
}

export interface BoutiqueLineSheetSetPathParameter {
  boutiqueId: number;
  lineSheetSetId: number;
}

export function getBoutiqueConfirmReadinessKey(
  parameter: BoutiqueLineSheetSetPathParameter | null
): SWRObjectKey<Record<string, never>> | null {
  if (parameter === null) {
    return null;
  }
  return {
    url: calcUrl(
      "/boutiques/:boutiqueId/pathpick/line-sheet-sets/:lineSheetSetId/confirm-readiness",
      parameter
    ),
    params: {},
  };
}

export function useBoutiqueConfirmReadiness(
  parameter: BoutiqueLineSheetSetPathParameter | null,
  config?: SWRConfiguration<BoutiqueConfirmReadinessResponse>
) {
  const fetcher = useFetcher<
    Record<string, never>,
    BoutiqueConfirmReadinessResponse
  >();
  return useSWR(getBoutiqueConfirmReadinessKey(parameter), fetcher, config);
}

export interface BoutiqueConfirmAllOrdersResponse {
  confirmedOrderSheetSetIds: number[];
  failed: { id: number; message: string }[];
}

const confirmAllOrdersKey: YWRKey<BoutiqueLineSheetSetPathParameter> = {
  url: (parameter) =>
    calcUrl(
      "/boutiques/:boutiqueId/pathpick/line-sheet-sets/:lineSheetSetId/confirm-all-orders",
      parameter
    ),
  method: "post",
};

export function useBoutiqueConfirmAllOrders() {
  const fetcher = useFetcher<
    Record<string, never>,
    BoutiqueConfirmAllOrdersResponse
  >();
  return useYWR(confirmAllOrdersKey, fetcher);
}
